import React, { useEffect, Suspense } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BuyerStatsProvider } from './context/BuyerStatsContext';
import CookieBanner from './components/CookieBanner';
import publicRoutes from './routes/publicRoutes';
import contentRoutes from './routes/contentRoutes';
import adminRoutes from './routes/adminRoutes';
import Home from './pages/HomePage';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import { PublicDesign } from './components/PublicDesign';
import { SeoMetadata } from './components/SeoMetadata';
import { Toaster } from 'sonner';

function App() {

  // GTM: Track Page Views bei Route-Wechsel (SPA)
  useEffect(() => {
    const handleRouteChange = () => {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'page_view',
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname
        });
      }
    };

    // Initial page view
    handleRouteChange();

    // Listen to route changes
    window.addEventListener('popstate', handleRouteChange);
    
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  return (
    <ErrorBoundary>
    <Toaster position="bottom-center" richColors toastOptions={{ style: { fontFamily: "'DM Sans', sans-serif" } }} />
    <BuyerStatsProvider>
      <div className="App">
        <BrowserRouter>
          <PublicDesign />
          <SeoMetadata />
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C6A15B]"></div></div>}>
          <Routes>
          {/* Homepage */}
          <Route path="/" element={<Home />} />
          
          {/* Admin Routes - MUST be before wildcard routes */}
          {adminRoutes}
          
          {/* Content Routes - SEO-optimierte Agrarflächen Seiten */}
          {contentRoutes}
          
          {/* Public Routes - Alle weiteren öffentlichen Seiten */}
          {publicRoutes}
          </Routes>
        </Suspense>
        <CookieBanner />
        
      </BrowserRouter>
      </div>
    </BuyerStatsProvider>
  </ErrorBoundary>
  );
}

// The review is isolated from the public app: no shared theme overrides or forms.
const DesignComparisonPage = React.lazy(() => import('./pages/designComparison/DesignComparisonPage'));
const AppEntry = () => /^\/design-vergleich\/?$/.test(window.location.pathname)
  ? <Suspense fallback={<div role="status" data-testid="design-review-loading">Designvergleich wird geladen …</div>}><DesignComparisonPage /></Suspense>
  : <App />;

export default AppEntry;
